import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { Uuid } from 'src/apis/api-utilities';
import type { ReshuffleRequest } from 'src/apis/reshuffle-service/types';
import type { ReshuffleServiceRootRequest } from 'src/apis/reshuffle-service/use-reshuffle-service';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';

type HookConfig = {
  reshuffleServiceRoot: ReshuffleServiceRootRequest;
  reshuffleRequestId: Uuid;
};

type ExecuteProps = {
  url: string;
};

export function useReshuffleRequest({
  reshuffleServiceRoot,
  reshuffleRequestId,
}: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<ReshuffleRequest>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!reshuffleServiceRoot.response) return;

    if (!reshuffleServiceRoot.response.data._links?.getReshuffleRequest)
      throw new Forbidden();

    const url = urlTemplate
      .parse(reshuffleServiceRoot.response.data._links.getReshuffleRequest.href)
      .expand({ reshuffleRequestId });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [reshuffleServiceRoot.response, reshuffleRequestId]);

  return request;
}

export type ReshuffleRequestRequest = ReturnType<typeof useReshuffleRequest>;
